export const normalizeScheduleTimeValue = (timeOfDay: string, fallback = '00:00:00') => {
  if (!timeOfDay) return fallback

  const match = String(timeOfDay)
    .trim()
    .match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/)
  if (!match) return fallback

  const hour = Number(match[1])
  const minute = Number(match[2])
  const second = Number(match[3] || '0')

  if (hour < 0 || hour > 23 || minute < 0 || minute > 59 || second < 0 || second > 59) {
    return fallback
  }

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`
}

export const scheduleTimeValueForInput = (timeOfDay: string, fallback = '00:00') => {
  const normalized = normalizeScheduleTimeValue(timeOfDay, `${fallback}:00`)
  return normalized.slice(0, 5)
}
